package com.tovtalk.ui.adaptive

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
actual fun rememberScreenWidthDp(): State<Float> {
    val widthState = remember { mutableStateOf(window.innerWidth.toFloat()) }
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            widthState.value = window.innerWidth.toFloat()
        }
        window.addEventListener("resize", listener)
        onDispose {
            window.removeEventListener("resize", listener)
        }
    }
    return widthState
}
